export const EMAIL = 'EMAIL'

// ERROR MESSAGES
export const GENERIC_UPDATE_ERROR_MESSAGE =
  'Please try again or contact support if the problem persists.'
export const EMAIL_TAKEN_ERROR_MESSAGE =
  'Try another email or contact support if the issue persists.'
export const COMPANY_NAME_TAKEN_ERROR_MESSAGE =
  'Company name already exists, please enter a different name'
